import ObserverRate from './Rate';
export default ObserverRate;
